<script lang="ts">

  export let price: string = "0";
  export let showCurrency: boolean = false;
  export let isNegative: boolean = false;
  export let discount: number = 1;

  $: formatPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: 'USD',
    currencyDisplay: showCurrency ? "symbol" : "narrowSymbol",
  }).format(parseFloat(price) / 100 * discount);
</script>

<span>
    {#if isNegative}
        -
    {/if}
  {formatPrice}
</span>
